import PropTypes from "prop-types";

const ChangePasswordModal = ({
  currentUserRole,
  passwordData,
  setPasswordData,
  handleChangePassword,
  handleCancelChangePassword,
}) => {
  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Change Password</h3>

        {/* แสดง Old Password เฉพาะกรณีที่ผู้ใช้ไม่ใช่ admin */}
        {currentUserRole === "systemAdmin" && (
          <div className="form-control">
            <label className="label">Old Password</label>
            <input
              type="password"
              value={passwordData.oldPassword}
              onChange={(e) =>
                setPasswordData({
                  ...passwordData,
                  oldPassword: e.target.value,
                })
              }
              className="input input-bordered"
            />
          </div>
        )}

        <div className="form-control">
          <label className="label">New Password</label>
          <input
            type="password"
            value={passwordData.newPassword}
            onChange={(e) =>
              setPasswordData({
                ...passwordData,
                newPassword: e.target.value,
              })
            }
            className="input input-bordered"
          />
        </div>
        <div className="form-control">
          <label className="label">Confirm New Password</label>
          <input
            type="password"
            value={passwordData.confirmPassword}
            onChange={(e) =>
              setPasswordData({
                ...passwordData,
                confirmPassword: e.target.value,
              })
            }
            className="input input-bordered"
          />
        </div>
        <div className="modal-action">
          <button className="btn btn-primary" onClick={handleChangePassword}>
            Change Password
          </button>
          <button className="btn" onClick={handleCancelChangePassword}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
ChangePasswordModal.propTypes = {
    currentUserRole: PropTypes.string.isRequired,
    passwordData: PropTypes.object.isRequired,
    setPasswordData: PropTypes.func.isRequired,
    handleChangePassword: PropTypes.func.isRequired,
    handleCancelChangePassword: PropTypes.func.isRequired,
};

export default ChangePasswordModal;